import moment, {type Moment} from 'moment';

import {getCalendarWeeks} from 'nutshell-core';

import {Stack} from '../../layout/stack/stack';
import type {StackSpacing} from '../../layout/stack/stack';

import {CalendarHeatmapDay} from './calendar-heatmap-day';
import type {
    CalendarHeatmapColorVariant,
    CalendarHeatmapDay as CalendarHeatmapDayType,
} from './types';

type Props = {
    dates: CalendarHeatmapDayType[];
    onDateClick: (day: CalendarHeatmapDayType) => void;
    columnGap?: StackSpacing;
    rowGap?: StackSpacing;
    colorVariant: CalendarHeatmapColorVariant;
};

export function CalendarHeatmapDates(props: Props) {
    const weekArray = getCalendarWeeks(moment(props.dates[0]?.date));

    return (
        <Stack spacing={props.rowGap}>
            {weekArray.map((week: Moment[]) => (
                <Stack
                    key={week.find(Boolean)?.toString()}
                    spacing={props.columnGap}
                    isHorizontal={true}
                    alignItems='center'
                >
                    {week.map((day: Moment | null, i: number) => {
                        const dateData = props.dates.find(
                            (d) => d.date === day?.format('YYYY-MM-DD')
                        );

                        return (
                            <CalendarHeatmapDay
                                key={i}
                                onClick={dateData ? props.onDateClick : undefined}
                                dateData={dateData}
                                date={day}
                                colorVariant={props.colorVariant}
                            />
                        );
                    })}
                </Stack>
            ))}
        </Stack>
    );
}
